import * as yup from 'yup'
import i18n from '../../i18n'
import { PrintTemplateDetail } from './types'
export const filterSchema = yup.object().shape(
  {
    ocr_input: yup.mixed().when('consignor', {
      is: (consignor: string) => !consignor,
      then: () =>
        yup
          .mixed()
          .test(
            'fileRequired',
            i18n.t('validations.required', {
              field: i18n.t('ocrImports.file_input'),
            }),
            (value) =>
              value instanceof File ||
              (Array.isArray(value) && value.length > 0)
          )
          .required(
            i18n.t('validations.atLeastOne', {
              field: `${i18n.t('ocrImports.file_input')}/${i18n.t(
                'invoices.filters.consignor'
              )}`,
            })
          ),
    }),
    consignor: yup.string().when('ocr_input', {
      is: (ocr_input: File) => !ocr_input,
      then: () =>
        yup.string().required(
          i18n.t('validations.atLeastOne', {
            field: `${i18n.t('invoices.filters.consignor')}/${i18n.t(
              'ocrImports.file_input'
            )}`,
          })
        ),
    }),
  },
  [['ocr_input', 'consignor']]
)

export const sheetSchema = yup
  .array()
  .of(
    yup.object().shape({
      checked: yup.boolean().default(false),
      product: yup
        .mixed()
        .test((value) => typeof value === 'string' || typeof value === 'number')
        .required(
          i18n.t('validations.required', {
            field: i18n.t('invoices.fields.product'),
          })
        ),
      quantity: yup
        .number()
        .test(
          'is-decimal',
          i18n.t('validations.decimal', {
            field: i18n.t('invoices.fields.quantity'),
            decimal: 10,
          }),
          (value) => /^\d+(\.\d{1,10})?$/.test(value?.toString() || '')
        )
        .required(
          i18n.t('validations.required', {
            field: i18n.t('invoices.fields.quantity'),
          })
        ),
      unit_price: yup
        .number()
        .test(
          'is-decimal',
          i18n.t('validations.decimal', {
            field: i18n.t('invoices.fields.unit_price'),
            decimal: 10,
          }),
          (value) => /^\d+(\.\d{1,10})?$/.test(value?.toString() || '')
        )
        .required(
          i18n.t('validations.required', {
            field: i18n.t('invoices.fields.unit_price'),
          })
        ),
      total_price: yup
        .number()
        .test(
          'is-decimal',
          i18n.t('validations.decimal', {
            field: i18n.t('invoices.fields.total_price'),
            decimal: 10,
          }),
          (value) => /^\d+(\.\d{1,10})?$/.test(value?.toString() || '')
        )
        .required(
          i18n.t('validations.required', {
            field: i18n.t('invoices.fields.total_price'),
          })
        ),
      jan_code: yup.string().nullable(),
    })
  )
  .required()
  .transform((value) =>
    value.map((v: PrintTemplateDetail) => ({
      ...v,
      product: v.product
        ? v.product.id !== undefined
          ? v.product.id
          : v.product.product_name
        : null,
    }))
  )

export const templateNameSchema = yup
  .string()
  .max(
    50,
    i18n.t('validations.maxLength', {
      field: i18n.t('ocrImports.template_name'),
      max: 50,
    })
  )
  .required(
    i18n.t('validations.required', {
      field: i18n.t('ocrImports.template_name'),
    })
  )
